import { render } from "./SnapshotFab.vue?vue&type=template&id=493edc31&scoped=true"
import script from "./SnapshotFab.vue?vue&type=script&lang=js"
export * from "./SnapshotFab.vue?vue&type=script&lang=js"

import "./SnapshotFab.vue?vue&type=style&index=0&id=493edc31&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493edc31"]])

export default __exports__